import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  root: {
    padding: 8,
    marginTop: 3,
    marginBottom: 3,
    borderRadius: 5,
    alignItems: "center",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.props.border,
    boxSizing: "border-box",
  },
  focused: {
    borderColor: theme.palette.primary.main,
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  editor: {
    padding: 8,
    width: "100%",
    boxSizing: "border-box",
    fontSize: "inherit",
    fontWeight: "inherit",
    color: "inherit",
    fontFamily: "inherit",
  },
}));

export default useStyle;